import * as React from "react";
import { sha256 } from "@grandvisionhq/lib-utils-w3c";
import { useFeatureToggles, useSelector } from "@grandvisionhq/state";
import { getAuth } from "../../selectors.js";
import { AuthState } from "../../state.js";
import { useAccount } from "./use-account.js";
const useCommonUserProperties = () => {
  const authState = useAccount();
  const { isMyAccountEnabled } = useFeatureToggles();
  const auth = useSelector(getAuth);
  return React.useCallback(
    async (email) => {
      if (!isMyAccountEnabled) {
        return {
          User_LoginStatus: "Guest",
          User_Email_SHA256: ""
        };
      }
      if (authState === "UNKNOWN") return;
      let hashedEmail = "";
      const isUserLoggedIn = authState === AuthState.LoggedIn;
      if (isUserLoggedIn) {
        try {
          hashedEmail = await sha256(auth.email);
        } catch (error) {
          console.error("Failed to hash email:", error);
        }
      } else if (email) {
        try {
          hashedEmail = await sha256(email);
        } catch (error) {
          console.error("Failed to hash email:", error);
        }
      }
      return {
        User_LoginStatus: isUserLoggedIn ? "Logged" : "Guest",
        User_Email_SHA256: hashedEmail
      };
    },
    [authState, isMyAccountEnabled, auth.email]
  );
};
export {
  useCommonUserProperties
};
//# sourceMappingURL=use-common-user-properties.js.map
